export default __webpack_public_path__ + "static/media/i_vasilenia.9234d799.svg";